import { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions } from '../../../context';
import Lock from '../Shared/Lock';
import AccountForm from './AccountForm';
import AccountInfo from './AccountInfo';

const Account = ({ refreshAccounts }) => {
    const { accountId } = useParams();
    const dispatch = useDispatch();
    const [account, setAccount] = useState({});
    const [locked, setLocked] = useState(true);

    const toggleLocked = useCallback(() => setLocked(!locked), [locked]);

    // TODO: show error in UI
    const refreshAccount = useCallback(() =>
        dispatch(actions.accounts.getAccount(accountId))
            .then((res) => setAccount(res))
            .then(() => setLocked(true)), [dispatch, accountId]);

    const refresh = useCallback(() => {
        refreshAccount();
        refreshAccounts();
    }, [refreshAccount, refreshAccounts]);

    useEffect(() => {
        setLocked(true);
        refreshAccount();
        // eslint-disable-next-line
    }, [dispatch, accountId]);
    
    return (
        <>
            <div className="d-flex justify-content-between mb-4">
                <div>
                    <h3>
                        {locked ? '' : 'Editing '}
                        {account?.firstName || 'Loading Account'}&nbsp;
                        {account?.lastName}
                    </h3>
                </div>
                <Lock isLocked={locked} onClick={toggleLocked} size="2x" />
            </div>
            <div style={{ maxHeight: '80vh', overflowY: 'scroll' }}>
                {locked ? (
                    <>
                        <AccountInfo label="Email">
                            <h4>{(account?.email || '').toLowerCase()}</h4>
                        </AccountInfo>
                        {account?.role && (
                            <AccountInfo label="Role">
                                <h4>{account?.role}</h4>
                            </AccountInfo>
                        )}
                        {(account?.partners || []).length > 0 && (
                            <AccountInfo label="Partners">
                                {(account?.partners || []).map((p) => (
                                    <h4 key={p.id}>{p.name}</h4>
                                ))}
                            </AccountInfo>
                        )}
                    </>
                ) : (
                    <AccountForm
                        account={account}
                        closeForm={toggleLocked}
                        refresh={refresh}
                    />
                )}
            </div>
        </>
    );
};

export default Account;
